import { Instagram } from "lucide-react";
import { Reveal, SunMark, WaveLine } from "./Reveal";
import { IMG, LINKS } from "@/constants/bbAssets";

export const InAction = () => (
  <section id="action" className="py-20 md:py-28 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-deep/70 flex items-center gap-2">
          <span className="w-8 h-px bg-sun" /> From the sand
        </p>
        <h2 className="mt-4 font-display uppercase text-deep leading-[0.95] text-[clamp(2.6rem,6vw,4.5rem)]">
          Beach Break in action.
        </h2>
      </Reveal>

      <div className="mt-12 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-7">
          <div className="photo-frame rotate-1" data-testid="action-photo-frame">
            <img
              src={IMG.selfie}
              alt="Athletes and coaches smiling together at a Beach Break clinic"
              className="w-full aspect-[16/10] object-cover"
              data-testid="action-photo"
            />
            <p className="pt-2.5 font-mono text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-deep/70">
              Clinic days — Tampa, FL
            </p>
          </div>
        </Reveal>

        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <SunMark className="w-10 h-8 text-sun" />
            <h3 className="mt-4 w-fit font-display uppercase text-deep leading-[1.05] text-[clamp(2rem,4.5vw,3.4rem)]">
              <span className="block">Good Vibes</span>
              <span className="block text-center text-sun py-1">×</span>
              <span className="block">Volleyball</span>
            </h3>
            <WaveLine className="mt-3 w-40 h-5 text-aqua" />
            <p className="mt-6 text-base md:text-lg text-deep-soft leading-relaxed">
              Your beach break starts here. Camps and clinics to learn something new, build
              community, and keep playing the game you love.
            </p>
            <a
              data-testid="instagram-link"
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2.5 border border-deep/25 text-deep font-mono text-[11px] uppercase tracking-[0.18em] px-6 py-3.5 rounded-full hover:bg-deep hover:text-cream transition-colors duration-200"
            >
              <Instagram className="w-4 h-4" />
              {LINKS.instagramHandle}
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default InAction;
